import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { FileBody, FileCard, FileIcon, FileMeta, FileNameLine, FileRemove, FileTitle, ProgressTrack } from './styled';

const ProofFileCard = ({
  detail,
  generatedName,
  href,
  name,
  onRemove,
  removeLabel,
  status,
}: {
  detail?: string;
  generatedName?: string;
  href?: string;
  name: string;
  onRemove?: () => void;
  removeLabel: string;
  status: 'uploading' | 'complete' | 'stored';
}) => {
  const showBoth = Boolean(generatedName && name && generatedName !== name);
  return (
    <FileCard>
      <FileIcon>
        <PictureAsPdfOutlinedIcon />
      </FileIcon>
      <FileBody>
        <FileTitle>
          {status === 'uploading' && 'Uploading'}
          {status === 'complete' && (
            <>
              Upload completed
              <CheckCircleIcon />
            </>
          )}
          {status === 'stored' &&
            (href ? (
              <a href={href} rel="noopener noreferrer" target="_blank" title={href}>
                {name}
              </a>
            ) : (
              name
            ))}
        </FileTitle>
        {showBoth ? (
          <>
            <FileNameLine>Original: {name}</FileNameLine>
            <FileNameLine>
              Generated:{' '}
              {href ? (
                <a href={href} rel="noopener noreferrer" target="_blank" title={href}>
                  {generatedName}
                </a>
              ) : (
                generatedName
              )}
            </FileNameLine>
            {detail ? <FileNameLine>{detail}</FileNameLine> : null}
          </>
        ) : (
          <FileMeta>
            {status === 'stored' ? (
              detail
            ) : (
              <>
                <span>{generatedName || name}</span>
                {detail ? <span>{detail}</span> : null}
              </>
            )}
          </FileMeta>
        )}
        {status !== 'stored' && (
          <ProgressTrack data-complete={status === 'complete' ? 'true' : undefined}>
            <span />
          </ProgressTrack>
        )}
      </FileBody>
      {onRemove && (
        <FileRemove type="button" aria-label={removeLabel} onClick={onRemove}>
          <DeleteOutlineIcon />
        </FileRemove>
      )}
    </FileCard>
  );
};

export default ProofFileCard;
